module.exports = __webpack_public_path__ + "img/aiActionsImage.ea44d335.png";